import React, { useState, useEffect } from "react";
import Select from "react-select";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import Header from "./Header.js";
import "./Search.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { SaveData } from "../Actions/HomeAction";

function SearchDetails(props) {
  const [isActiveSummary, setActiveSummary] = useState();
  const [summary, setSummary] = useState([]);
  const [judgement, setJudgement] = useState([]);
  const [judgementStructure, setJudgementStructure] = useState([]);
  const [NER, setNER] = useState([]);
  const [nerText, setNerText] = useState();
  const [extractiveText, setExtractiveText] = useState();
  const [LabelsForNER, setLabelsForNER] = useState();
  const [LabelsForNER2, setLabelsForNER2] = useState();
  const [labelsForNEROptions, setLabelsForNEROptions] = useState(undefined);
  const [highLight, setHighLight] = useState([
    "PREAMBLE",
    "NONE",
    "FAC",
    "ARG_PETITIONER",
    "STA",
    "ANALYSIS",
    "ISSUE",
    "RPC",
    "RATIO",
    "PRE_RELIED",
    "RLC",
  ]);
  const [testOptions, setTestOptions] = useState(undefined);
  const [judgementCalue, setJudgementValue] = useState(undefined);
  const [judgementOptions, setJudgementOptions] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [filterData, setFilterData] = useState(undefined);
  var regexQuery =
    "^(https?://)?(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$";
  var url = new RegExp(regexQuery, "i");



  useEffect(() => {

    if ((props?.data !== '') && (props?.data.length > 0)) {
      var axios = require("axios");
      var data = JSON.stringify({
        text: url.test(props?.data) ? props?.data.trim() : props?.data,
        inference_token: "9a247b302d634c77a03f2f71b8d4b99b",
        api_call: "RhetoricalRole",
      });

      var config = {
        method: "post",
        url: "https://api-opennyai-webapp-fer6v2lowq-uc.a.run.app/predictions/MultipleAPIRediredtor/",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      setIsLoading(true);
      axios(props?.data ? config : '')
        .then((result) => {
          setIsLoading(false);
          setJudgement(result.data);
          return result.data;
        })
        .then((response) => {
          setExtractiveText(response[0]);
          setNerText(response[0].data.text);
          setSummary(response.data);
        });
      }
  }, [props?.data]);

  useEffect(() => {
    if (nerText && props?.data !== '') {
    var axios = require("axios");
    var config3 = {
      method: "post",
      url: "https://api-opennyai-webapp-fer6v2lowq-uc.a.run.app/predictions/MultipleAPIRediredtor/",
      headers: {
        "Content-Type": "application/json",
      },
      data: { txt: nerText, inference_token: "9a247b302d634c77a03f2f71b8d4b99b",api_call: "LegalNER" },
    };

    axios(config3)
      .then((result) => {
        return result;
      })
      .then((res) => {
        setNER(res.data);
      });
    }
  }, [nerText]);

  useEffect(() => {
    if (extractiveText && (props?.data !== '')) {
      var axios = require("axios");
      var config2 = {
        method: "post",
        url: "https://api-opennyai-webapp-fer6v2lowq-uc.a.run.app/predictions/MultipleAPIRediredtor/",
        headers: {
          "Content-Type": "application/json",
        },
        data: [extractiveText],
      };
      setIsLoading(true);
      axios(config2)
      .then((result2) => {
        setIsLoading(false);
        return result2;
      })
      .then((res) => {
        setJudgementStructure(res.data);
      });
    }
  }, [extractiveText]);

    const newJudgement = judgement?.map((item) => item?.annotations[0]);
    const resultForJudgement = newJudgement?.map((item) => item?.result);
    const valueForJudgemenr = resultForJudgement[0]?.map((item) => item?.value);

  useEffect(() => {
    const seen = new Set();
  
    const updatedArray = valueForJudgemenr?.filter((el) => {
      const duplicate = seen.has(el?.labels[0]);
      seen.add(el?.labels[0]);
      return !duplicate;
    });
  
    const lablesData = updatedArray?.map((item) => item?.labels);
    const lablesOption = lablesData?.map((item, index) => ({
      value: index,
      label: item,
    }));
    setJudgementValue(lablesOption)
    setJudgementOptions(lablesOption)
  },[judgement])

  const NewLablesArray = valueForJudgemenr?.map((item) => [
    item.labels[0],
    item.text,
  ]);
  var matchVariable = NewLablesArray?.length > 1 && NewLablesArray[0][0];

  const activeData = (item) => {
    setJudgementValue(item)
    return setHighLight(item.map((item1) => item1.label[0]));
  };

  useEffect(() => {
    const newJugemnetKey = Object.entries(judgementStructure);
    let UpdatedfilterData = newJugemnetKey?.filter(
      (item, idx) => idx <= newJugemnetKey.length - 2
    );
    setFilterData(UpdatedfilterData)
  },[judgementStructure])

  useEffect(() => {
    if(filterData){
      setActiveSummary(filterData[0])
    }
  },[filterData])

  const setMatchVariable = (value) => {
    matchVariable = value;
  };

  const activeDataSummary = (item) => () => {
    setActiveSummary(item);
  };
  
  useEffect(() => {
    setLabelsForNER(NER.html_markup_txt)
  },[NER.html_markup_txt])

  useEffect(() => {
    const NewLableNER = LabelsForNER?.split(">")?.filter((item) =>
      item.includes("</span")
    );
    const NewFilterLables = NewLableNER?.map((item) => item?.split("</span")[0]);
    let uniqueChars = [...new Set(NewFilterLables)];
    const NERLablesArray = uniqueChars?.map((item, idx) => ({
      value: item+'item',
      label: item,
    }));
    setTestOptions(NERLablesArray)
  },[LabelsForNER])

  useEffect(() => {
    setLabelsForNER2(testOptions)
    setLabelsForNEROptions(testOptions)
  },[testOptions])

  const removeColor = (item) => {
    setLabelsForNER2(item)
    const element = document.querySelectorAll("mark");
    let NewElement = labelsForNEROptions?.filter((ele) => {
      return !item?.find((ele1) => ele1?.label === ele?.label);
    });
    for (let i = 0; i <= element.length; i++) {
      let FoundEle = NewElement?.find(
        (item) => item?.label == element[i]?.childNodes[1].innerHTML
      );
      if (FoundEle) {
        element[i]?.classList.add("active-add");
      }
      if (!FoundEle) {
        element[i]?.classList.remove("active-add");
      }
    }
  };

  const colorData = {
    PREAMBLE: "#ABDEE6",
    NONE: "#f5b8f5",
    FAC: "#FFFFB5",
    ARG_PETITIONER: "#F3B0C3",
    STA: "#B6CFB6",
    ANALYSIS: "#FEE1E8",
    ISSUE: "#ECEAE4",
    RPC: "#CBAACB",
    RATIO: "#FFC8A2",
    PRE_RELIED: "#55CBCD",
    RLC: "#C6DBDA",
  };

  return (
    <div className="searchDetails">
      <Container className={isLoading ? "loading-spinner" : ""}>
        <Header />
        <Tabs
          defaultActiveKey="summary"
          id="uncontrolled-tab-example"
          className="mb-3 tabSection"
        >
          <Tab eventKey="summary" title="Summary">
            <Row>
              <Col xs={12} md={2}>
                <ul className="sideNav">
                  {filterData?.map((item) => {
                    return(
                    <li>
                      <a
                        href={"#" + item[0]}
                        className={isActiveSummary && isActiveSummary[0] === item[0] ? "active" : ""}
                        onClick={activeDataSummary(item)}
                      >
                        {item[0]}
                      </a>
                    </li>
                  )
                  })}
                </ul>
              </Col>
              <Col xs={12} md={10}>
                {filterData?.map((item) => (
                  <div
                    id={item[0]}
                    className={
                      isActiveSummary && isActiveSummary[0] === item[0]
                        ? "tab-info active"
                        : "tab-info"
                    }
                  >
                    <p
                      dangerouslySetInnerHTML={{
                        __html: item[1].replaceAll("\n", "<br />").replaceAll(/   /g, "&nbsp;&nbsp;"),
                      }}
                    />
                  </div>
                ))}
              </Col>
            </Row>
          </Tab>
          <Tab eventKey="judgement" title="Show Judgement Structure">
            <Row>
              <Col className="tagItems">
                {judgementOptions?.length > 0 ? (
                  <Select
                    value={judgementCalue}
                    isMulti
                    onChange={activeData}
                    options={judgementOptions}
                  />
                ) : (
                  ""
                )}
              </Col>
            </Row>
            <Row>
              <Col className="judgementData">
                {NewLablesArray?.map((item, idx) => (
                  <div>
                    <span
                      id={item[0]}
                      style={{
                        backgroundColor:
                          highLight.indexOf(item[0]) > -1
                            ? colorData[item[0]]
                            : "",
                      }}
                    >
                      <span
                        dangerouslySetInnerHTML={{
                          __html: item[1]
                            .toString()
                            .replace("\\n", "<br />")
                            .replaceAll(/   /g, "&nbsp;&nbsp;")
                            .replace(/\n/g, "<br />"),
                        }}
                      />
                      {idx < NewLablesArray?.length - 1 ? (
                        matchVariable != NewLablesArray[idx + 1][0] && (
                          <span className="label-tag">
                            {item[0]}
                            {setMatchVariable(NewLablesArray[idx + 1][0])}
                          </span>
                        )
                      ) : (
                        <span className="label-tag">{item[0]}</span>
                      )}
                    </span>
                  </div>
                ))}
              </Col>
            </Row>
          </Tab>
          <Tab eventKey="NER" title="NER">
            <Row>
              <Col className="tagItems">
                {labelsForNEROptions?.length > 0 && (
                  <Select
                    value={LabelsForNER2}
                    isMulti
                    name="ner"
                    onChange={removeColor}
                    options={labelsForNEROptions}
                  />
                )}
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: NER?.html_markup_txt
                      ?.replace("\\n", "<br />")
                      ?.replace(/.\\n/g, ".")
                      ?.replace(/\\/g, ""),
                  }}
                />
              </Col>
            </Row>
          </Tab>
        </Tabs>
      </Container>
    </div>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({ SaveData }, dispatch),
  };
}

const mapStateToProps = (state) => ({
  data: state.homeReducer.data,
});
export default connect(mapStateToProps, mapDispatchToProps)(SearchDetails);